// src/hooks/useAutoTranslate.js
import { useState, useEffect, useContext } from 'react';
import { LanguageContext } from '../context/LanguageContext';

export const useAutoTranslate = (text) => {
  const { language } = useContext(LanguageContext);
  const [translatedText, setTranslatedText] = useState(text);

  useEffect(() => {
    if (language === 'ru') {
      setTranslatedText(text);
    } else {
      const translateText = async () => {
        try {
          const response = await fetch(
            `https://api.mymemory.translated.net/get?q=${encodeURIComponent(text)}&langpair=ru|en`
          );
          const data = await response.json();
          let result = data.responseData.translatedText;
          // Убираем лишнюю ";" в конце строки, если она есть
          result = result.trim().replace(/;$/, '');
          setTranslatedText(result);
        } catch (error) {
          console.error("Translation error:", error);
          setTranslatedText(text);
        }
      };
      translateText();
    }
  }, [language, text]);

  return translatedText;
};
